<div class="pt-3 pl-md-4">

  <h2 class="mb-3">Linked Products</h2>

  <p class="text-muted" *ngIf="loading">Loading...</p>

  <p class="text-danger" *ngIf="serverError !== null">
    Server Error: {{ serverError }}
  </p>

  <ng-container *ngIf="!loading && (serverError === null)">

    <p class="text-muted" *ngIf="linkedEventTypes.length === 0">
      No products are using this document template.
    </p>

    <div class="rounded-table-wrapper table-responsive-lg" *ngIf="linkedEventTypes.length > 0">
      <table class="table">

        <thead>
        <tr>
          <th scope="col">Event Type</th>
          <th scope="col">Used As</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let link of linkedEventTypes">
          <td>
            <a [routerLink]="'/events/setup/edit/' + link.event_type_id.toString() + '/details'"
               target="_blank">
              {{ link.event_type_name }}
            </a>
          </td>
          <td>{{ link.relationship }}</td>
        </tr>
        </tbody>

      </table>
    </div>

  </ng-container>

</div>
